import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Auth } from 'src/app/models/auth';
import { Fuels, Species, Vehicle } from 'src/app/models/vehicle';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { VehicleService } from 'src/app/services/vehicles.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { GenericValidator } from 'src/app/shared/validators/generic-validator.validator';

@Component({
  selector: 'app-veiculos-edit',
  templateUrl: './veiculos-edit.component.html',
  styleUrls: ['./veiculos-edit.component.css']
})
export class VeiculosEditComponent implements OnInit {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private alertService: NewAlertService,
    private vehicleService: VehicleService,
    private authenticationService: AuthenticationService,

  ) { }

  public get form() {
    return this.vehicleFormGroup.controls;
  }

  private currentUser: Auth;

  public vehicleFormGroup: FormGroup;
  public vehicleEdit: Vehicle;
  public speciesList: Species[];
  public fuelsList: Fuels[];

  private vehicleGuid: string;

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;

    this.route.paramMap.subscribe(params => {
      this.vehicleGuid = params.get('id');
    });

    this.loadLists();
    this.createForm();
    this.getvehicle()
  }

  getvehicle() {
    this.vehicleService.getvehicleDetails(this.vehicleGuid, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId)
      .subscribe(response => {
        if (response.status === ApiError.Sucesso) {
          this.vehicleEdit = response.result;
          this.createForm();
        }
      });
  }

  loadLists() {
    this.vehicleService.getSpecies()
      .subscribe(response => {
        this.speciesList = response.result.filter(x => x.isActive);
      });
    this.vehicleService.getFuels()
      .subscribe(response => {
        this.fuelsList = response.result;
      });
  }

  createForm() {
    const today = new Date();
    this.vehicleFormGroup = this.formBuilder.group({
      nickName: new FormControl(this.vehicleEdit?.nickName, [
        Validators.required
      ]),
      registrationPlate: new FormControl(this.vehicleEdit?.registrationPlate, [
        Validators.required,
        Validators.pattern('^[a-zA-Z]{3}[0-9]{1}[a-zA-Z0-9]{1}[0-9]{2}$'),
        Validators.minLength(7),
        Validators.maxLength(7)
      ]),
      manufacturer: new FormControl(this.vehicleEdit?.manufacturer, [
        Validators.required
      ]),
      model: new FormControl(this.vehicleEdit?.model, [
        Validators.required
      ]),
      modelYear: new FormControl(this.vehicleEdit?.modelYear, [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(4)
      ]),
      manufactureYear: new FormControl(this.vehicleEdit?.manufactureYear, [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(4)
      ]),
      renavam: new FormControl(this.vehicleEdit?.renavam, [
        Validators.required,
        Validators.maxLength(11)
      ]),
      fuelConsumption: new FormControl(this.vehicleEdit?.fuelConsumption, [
        Validators.required
      ]),
      specieId: new FormControl(this.vehicleEdit?.specieId, [
        Validators.required,
      ]),
      fuelId: new FormControl(this.vehicleEdit?.fuelId, [
        Validators.required,
      ]),
      transactionsPerDay: new FormControl(this.vehicleEdit?.transactionsPerDay, [
      ]),
      transactionMaxValue: new FormControl(this.vehicleEdit?.transactionMaxValue, [
      ]),
      transactionsMaxValuePerDay: new FormControl(this.vehicleEdit?.transactionsMaxValuePerDay, [
      ])
    });
  }

  enableDisable(enable) {
    this.vehicleService.enableDisablevehicle(this.vehicleGuid, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId, !enable)
      .subscribe(response => {
        if (response.status === ApiError.Sucesso) {
          if(enable) this.alertService.success("Veículo desativado com sucesso!", true);
          else  this.alertService.success("Veículo ativado com sucesso!", true);
          this.vehicleEdit.isActive = !enable
        } else {
          this.alertService.error("Falha ao cadastrar favorecido", true);
        }
      });
  }

  onSubmit(vehicleUpdate: Vehicle) {
    if (this.vehicleFormGroup.valid) {
      this.vehicleService.updatevehicle(this.vehicleGuid, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId, vehicleUpdate)
        .subscribe(response => {
          if (response.status === ApiError.Sucesso) {
            this.alertService.success("Veículo cadastrado com sucesso!", true);

            this.router.navigate([`list`], { relativeTo: this.route.parent });
          } else {
            this.alertService.error("Falha ao cadastrar favorecido", true);
          }
        });
    } else {
      GenericValidator.verifierValidatorsForm(this.vehicleFormGroup);
    }
  }

  goToBack() {
    this.router.navigate(['portal/veiculos/list']);
  }
}
